/**
 * Chat-completions code generators.
 *
 * Generates code snippets for the Perceptron `/v1/chat/completions` API (used by
 * the demo's Compose mode) in the supported languages. This API owns its own
 * config type (`ExportCodeConfig`) and generators; the parent
 * `codeGenerators/index.ts` re-export hub exposes it per-API.
 */

import { generateCurl } from "./curl";
import { generatePython } from "./python";
import { ExportCodeConfig, ExportLanguage } from "./types";

export * from "./types";
export { generateCurl } from "./curl";
export { generatePython } from "./python";

/** Generate chat-completions code for the specified language. */
export function generateChatCompletionsCode(config: ExportCodeConfig, language: ExportLanguage): string {
  switch (language) {
    case "python":
      return generatePython(config);
    case "curl":
      return generateCurl(config);
    default:
      throw new Error(`Unsupported language: ${language}`);
  }
}
